<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog persistent v-model="$auth.loginPopup" width="auto " :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-form v-on:submit.prevent="login">
            <v-card>
                <v-card-title class="text-center justify-center py-6">
                    <div class="text-h6 text-sm-h4">{{ language.t('Login.login') }}</div>
                </v-card-title>
                <v-card-text class="text-center justify-center py-6">
                    <v-alert v-if="$auth.loginError" dense border="left" type="warning">{{
                        language.t('Login.' + $auth.loginError) }}</v-alert>
                    <v-progress-linear v-if="$auth.loading" indeterminate color="primary" class="mb-0">
                    </v-progress-linear>
                    <v-text-field v-model="username" ref="username" :value="username"
                        :label="language.t('Forms.emailAddress')" :disabled="$auth.loading"></v-text-field>
                    <v-text-field v-model="password" :value="password" :label="language.t('Forms.password')" type="password"
                        :disabled="$auth.loading"></v-text-field>
                    <v-btn @click="newPassword" elevation="0" text>{{ language.t('Login.ForgotPassword') }}</v-btn>
                </v-card-text>
                <v-card-actions class="card-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="success" x-large :disabled="$auth.loading" type="submit">
                        <v-icon>mdi-check</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
export default {
    components: {
    },
    props: {
    },
    data() {
        return {
            username: "",
            password: "",
        }
    },
    computed: {
        loginPopup() {
            return this.$auth.loginPopup;
        }
    },
    watch: {
        /* login popup is opened/closed */
        loginPopup(val) {
            // focus on username input when popup is opened
            if (!val) return;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.username.$el.querySelector('input').focus();
                }, 0);
            });
        },
    },
    methods: {
        login() {
            this.$auth.login(this.username, this.password);
            this.password = "";
        },
        newPassword() {
            if (this.username != "") {
                this.$axios.post(route('api.resetPassword', this.username)).then((res) => {
                    this.$auth.loginError = "EmailSent";
                }).catch((error) => {
                    this.$auth.loginError = error.response.data.reason;
                });
            }else{
                this.$auth.loginError = "__NO_IDENTIFIER"
            }
        }
    }
}
</script>
